<template>
  <div>
    <div
      v-show="!resettingpassword"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="card-title">
        <div
          class="col-12 pt-4 pb-4 text-center"
          :class="gdqmodeclass"
          style="color: white"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          />
        </div>
      </div>
      <div v-show="passwordhasbeenreset" class="alert alert-success">
        {{ message }}
      </div>
      <div
        v-show="gdq_recertification"
        class="alert alert-warning"
        v-html="gdq_recertification_text"
      />
      <form @submit.prevent="login">
        <div class="mb-3">
          <label class="form-label" for="login-username"
            >Enter your username</label
          >
          <input
            id="login-username"
            :class="`form-control ${anon ? 'g-anon' : ''} ${
              i_name_valid === false ? 'is-invalid' : ''
            }`"
            v-model="i_name"
            autocomplete="username"
          />
          <div v-if="i_name_valid === false" class="invalid-feedback">
            Incorrect or incomplete login information
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="login-password"
            >Enter your password</label
          >
          <input
            id="login-password"
            v-model="i_password"
            type="password"
            :class="`form-control ${
              i_password_valid === false ? 'is-invalid' : ''
            }`"
            autocomplete="current-password"
          />
          <div v-if="i_password_valid === false" class="invalid-feedback">
            Incorrect or incomplete login information
          </div>
        </div>
        <div v-if="otp_setup" class="card col-12 mx-auto">
          <div class="card-header">Two-factor authentication required</div>
          <div class="card-body">
            <p>
              You have not set up two-factor authentication yet. Please scan the
              QR code below in your authenticator app , then enter the code from
              your authenticator app in the field below and click "Set up".
            </p>
            <div class="text-center">
              <img
                :src="qrCodeUrl"
                alt=""
                class="my-4"
                title="Scan this QR code with your authenticator app"
              />
            </div>
            <div class="mb-3 pt-4">
              <label class="form-label" for="otp-setup-code">
                Enter the code from your authenticator app:
              </label>
              <input
                id="otp-setup-code"
                v-model="otp_setup_code"
                type="text"
                placeholder="Code"
                class="form-control"
                autocomplete="one-time-code"
              />
            </div>
          </div>
        </div>
        <div v-if="otp" class="mb-3">
          <label class="form-label" for="otp-code"
            >Two factor authentication</label
          >
          <input
            id="otp-code"
            v-model="otp_code"
            type="text"
            placeholder="Enter the code from your authenticator app"
            class="form-control"
            autocomplete="one-time-code"
          />
        </div>
        <div v-if="otpemail" class="mb-3">
          <label class="form-label" for="otp-email-code"
            >A one-time login code has been sent to your e-mail, please enter
            the code</label
          >
          <input
            id="otp-email-code"
            v-model="otpemail_code"
            type="text"
            placeholder="Please enter e-mailed code"
            class="form-control"
            autocomplete="one-time-code"
          />
        </div>
        <div v-if="otp_setup || otp" class="mb-3 col-12 mx-auto text-center">
          <button class="btn btn-primary col-12 col-sm-6" type="submit">
            <div
              v-show="loading === true"
              class="spinner-border spinner-border-sm me-2 py-0"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
            <span class="icon-key ms-2 me-2" />{{
              otp_setup ? "Set up" : "Login"
            }}
          </button>
        </div>
        <div v-if="!otp_setup && !otp" class="col-12 mx-auto text-center">
          <button class="btn btn-primary col-12 col-sm-6" type="submit">
            <div
              v-show="loading === true"
              class="spinner-border spinner-border-sm me-2 py-0"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
            <span class="icon-key ms-2 me-2" />Login
          </button>
        </div>
        <div class="col-12 mx-auto mt-2 text-center">
          Do you want to change your password? Click
          <a href="javascript: return false" @click.prevent="resetpassword"
            >here</a
          >
          to reset it.
        </div>
      </form>
    </div>

    <div
      v-show="login_text.length > 10"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="col-12 pt-4 pb-4 text-left bg-default" v-html="login_text" />
    </div>
    <div
      v-show="resettingpassword"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="card-title">
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          />
        </div>
      </div>
      <h4>Reset password</h4>
      <form @submit.prevent="sendpasswordlink">
        <div class="mb-3">
          <label class="form-label" for="password-email"
            >Enter your e-mail address</label
          >
          <input
            id="password-email"
            type="email"
            :class="`form-control ${anon ? 'g-anon' : ''} ${
              passwordemail_valid === false ? 'is-invalid' : ''
            }`"
            v-model="passwordemail"
            autocomplete="email"
          />
          <div v-if="passwordemail_valid === false" class="invalid-feedback">
            Invalid e-mail address
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-5 text-left pb-4">
            <button
              class="btn btn-secondary col-12"
              type="button"
              @click.prevent="resettingpassword = false"
            >
              Back to login
            </button>
          </div>
          <div class="col-12 col-lg-7 text-right">
            <button class="btn btn-primary col-12" type="submit">
              <span class="icon-key me-2" />Send me the link!
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { config } from "../../config";

const store = useStore();

// Data properties
const gdqmodeclass =
  config.mode === "live"
    ? "bg-primary"
    : config.mode === "stage"
    ? "bg-warning"
    : "bg-danger";
const i_name = ref("");
const i_name_valid = ref(true);
const i_password = ref("");
const i_password_valid = ref(true);
const resettingpassword = ref(false);
const passwordhasbeenreset = ref(false);
const user = ref(null);
const message = ref("");
const passwordemail = ref("");
const passwordemail_valid = ref(null);
const loading = ref(false);
const lastlogin_months = ref(0);
const gdq_recertification_months = ref(1000);
const gdq_recertification_text = ref("");
const gdq_recertification = ref(false);
const login_text = ref("");
const otp_setup = ref(false);
const otp_setup_code = ref("");
const qrCodeUrl = ref("");
const otp = ref(false);
const otp_code = ref("");
const otp_secret = ref("");
const otpemail = ref(false);
const otpemail_code = ref("");

// Computed property
const anon = computed(() => {
  return store.state.anon;
});

// Methods
const consultantstatuses_get = () => {
  store.dispatch("consultantstatuses_fetch");
};

const get_login_text = () => {
  store.dispatch("syspref_get", { name: "login_text" }).then((resp) => {
    login_text.value = resp.data.value;
  });
};

const get_recertification_params = () => {
  store
    .dispatch("syspref_get", { name: "gdq_recertification_months" })
    .then((resp) => {
      gdq_recertification_months.value = resp.data.value;
      store
        .dispatch("syspref_get", { name: "gdq_recertification_text" })
        .then((resp) => {
          gdq_recertification_text.value = resp.data.value;
        });
    });
};

const lastlogin = (user, profile) => {
  // This one works, but we need to reset i_user.last_login to i_user.prev_login,
  // otherwise the user can log in the second time
  const checkdate =
    profile.certification_date > user.last_login
      ? profile.certification_date
      : user.last_login;
  lastlogin_months.value = 0;
  if (checkdate !== null) {
    const d1 = new Date(checkdate.replace(" ", "T"));
    const d2 = new Date();
    let months = 0;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth() + 1;
    lastlogin_months.value = months;
  }
};

const parse_email = (email) => {
  // eslint-disable-next-line
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(email.toLowerCase());
};

const sendpasswordlink = () => {
  let formok = true;
  passwordemail_valid.value = true;
  if (!parse_email(passwordemail.value)) {
    formok = false;
  }
  if (!formok) {
    passwordemail_valid.value = false;
  }
  // --------------------------------------------- --
  // Look up whether we have a user for this e-mail
  // --------------------------------------------- --
  const filter = {
    email: {
      operator: "=",
      value: passwordemail.value,
    },
  };
  store.dispatch("forgotpassword", { filter }).then((resp) => {
    const status = resp.data.status;
    passwordhasbeenreset.value = false;
    message.value = "";
    if (status === "OK") {
      passwordhasbeenreset.value = true;
      message.value =
        "An e-mail has been sent to " +
        passwordemail.value +
        ". Please follow the instructions in the e-mail to reset your password.";
    }
    resettingpassword.value = false;
  });
};

const resetpassword = () => {
  resettingpassword.value = true;
};

const login = () => {
  loading.value = true;
  i_name.value = i_name.value.trim();
  i_password.value = i_password.value.trim();
  const i_name_val = i_name.value;
  const i_password_val = i_password.value;
  const i_otp = otp.value ? otp_code.value : otp_setup_code.value;
  const i_otpemail = otpemail.value ? otpemail_code.value : "";

  store
    .dispatch("login", {
      i_name: i_name_val,
      i_password: i_password_val,
      i_otp,
      i_otpemail,
    })
    .then(() => {
      store.dispatch("user_fetch").then(() => {
        store.dispatch("profile_fetch", {}).then(() => {
          loading.value = false;
          i_name_valid.value = true;
          i_password_valid.value = true;
          gdq_recertification.value = false;
          lastlogin(store.state.user, store.state.profile);
          if (
            parseInt(lastlogin_months.value) >
            parseInt(gdq_recertification_months.value)
          ) {
            gdq_recertification.value = true;
            // Disabled
            gdq_recertification.value = false;
          }
          if (!gdq_recertification.value) {
            // Set last login on successful login and no recertification
            store
              .dispatch("lastlogin_set", { id: store.state.user.id })
              .then(() => {
                // Navigate to home page using direct window navigation
                // This avoids the undefined $router issue in Vue 3 + Vuex setup
                window.location.href = "/";
              });
          }
        });
      });
    })
    .catch((err) => {
      if (err.response) {
        loading.value = false;
        // Check for the x-two-factor-required header
        const twoFactorRequired = err.response.headers["x-two-factor-required"];
        if (twoFactorRequired === "true") {
          console.log("Two-factor authentication required");
          // Handle two-factor authentication requirement
          if (err.response.data.status === "2fa_setup") {
            console.log("Setup");
            otp_setup.value = true;
            qrCodeUrl.value = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURI(
              err.response.data.qr
            )}&size=200x200`;
          }
          if (err.response.data.status === "2fa") {
            otp_secret.value = err.response.data.secret;
            otp_setup.value = false;
            otp.value = true;
          }
          return;
        }
        const twoFactorEmailRequired =
          err.response.headers["x-two-factor-email-required"];
        if (twoFactorEmailRequired === "true") {
          otpemail.value = true;
          return;
        }
      }
      i_name_valid.value = false;
      i_password_valid.value = false;
      loading.value = false;
    });
};

// Lifecycle hook
onMounted(() => {
  consultantstatuses_get();
  get_recertification_params();
  get_login_text();
});
</script>

<style scoped></style>
